const ehrOptions = [
  { label: "AdvancedMD", value: "advancedmd" },
  { label: "Allscripts", value: "allscripts" },
  { label: "AllegianceMD", value: "allegiancemd" },
  { label: "Amazing Charts", value: "amazing_charts" },
  { label: "athenahealth", value: "athenahealth" },
  { label: "BestNotes", value: "bestnotes" },
  { label: "Bizmatics", value: "bizmatics" },
  { label: "BreezyNotes", value: "breezynotes" },
  { label: "CareCloud", value: "carecloud" },
  { label: "Charm EHR", value: "charm_ehr" },
  { label: "Charm Health", value: "charm_health" },
  { label: "ChartLogic", value: "chartlogic" },
  { label: "ChiroTouch", value: "chirotouch" },
  { label: "Compulink", value: "compulink" },
  { label: "CounSol", value: "counsol" },
  { label: "CPSI", value: "cpsi" },
  { label: "DrChrono", value: "drchrono" },
  { label: "eClinicalWorks", value: "eclinicalworks" },
  { label: "Elation Health", value: "elation_health" },
  { label: "Ensora", value: "ensora" },
  { label: "Epic", value: "epic" },
  { label: "Evident", value: "evident" },
  { label: "Freed", value: "freed" },
  { label: "GE Healthcare", value: "ge_healthcare" },
  { label: "Greenway Health", value: "greenway_health" },
  { label: "Healthie", value: "healthie" },
  { label: "InSync Healthcare Solutions", value: "insync_healthcare_solutions" },
  { label: "Insync", value: "insync" },
  { label: "Jane", value: "jane" },
  { label: "Kareo", value: "kareo" },
  { label: "Kipu", value: "kipu" },
  { label: "McKesson", value: "mckesson" },
  { label: "MEDITECH", value: "meditech" },
  { label: "ModMed", value: "modmed" },
  { label: "Netsmart", value: "netsmart" },
  { label: "NextGen Healthcare", value: "nextgen_healthcare" },
  { label: "OmniMD", value: "omnimd" },
  { label: "Oracle Health", value: "oracle_health" },
  { label: "patientNOW", value: "patientnow" },
  { label: "Practice EHR", value: "practice_ehr" },
  { label: "Practice Fusion", value: "practice_fusion" },
  { label: "Praxis EMR", value: "praxis_emr" },
  { label: "PrognoCIS", value: "prognocis" },
  { label: "Qualifacts", value: "qualifacts" },
  { label: "Sessions Health", value: "sessions_health" },
  { label: "Siemens Healthineers", value: "siemens_healthineers" },
  { label: "SimplePractice", value: "simple_practice" },
  { label: "TheraNest", value: "theranest" },
  { label: "TherapyNotes", value: "therapy_notes" },
  { label: "TruBridge", value: "trubridge" },
  { label: "UnitedHealth Optum", value: "unitedhealth_optum" },
  { label: "Valant", value: "valant" },
  { label: "Veradigm", value: "veradigm" },
  { label: "WebPT", value: "webpt" },
  { label: "WellSky", value: "wellsky" },
  { label: "zHealth", value: "zhealth" },
  { label: "Other", value: "other" },
];

const referralSource = [
  { label: "Google Search", value: "google" },
  { label: "Facebook Ad", value: "facebook-ad" },
  { label: "Facebook Group", value: "facebook-group" },
  { label: "Instagram", value: "instagram" },
  { label: "Colleague Referral", value: "colleague" },
  { label: "Conference/Event", value: "conference" },
  { label: "Other", value: "other" },
];

const tutorial = [
  {
    id: 1,
    youtubeId: "5jSXd7dqaHI",
    thumbnail: "general_thumbnail.png",
    title: "How to Create a Note (2 mins)",
  },
  {
    id: 2,
    youtubeId: "do6UR0xHxXc",
    thumbnail: "custom_template_thumbnail.png",
    title: "How to Create Your Own Template (2 mins)",
  },

  {
    id: 3,
    youtubeId: "z_6LTfPhszk",
    thumbnail: "ehr_thumbnail.png",
    title: "How to Integrate Nudge with Your EHR (3 mins)",
  },
];

export { ehrOptions, referralSource, tutorial };
